import { render, staticRenderFns } from "./DoctorSurgeriesHistory.vue?vue&type=template&id=1569afae&scoped=true"
import script from "./DoctorSurgeriesHistory.vue?vue&type=script&lang=js"
export * from "./DoctorSurgeriesHistory.vue?vue&type=script&lang=js"
import style0 from "./DoctorSurgeriesHistory.vue?vue&type=style&index=0&id=1569afae&prod&scoped=true&lang=css"
import style1 from "./DoctorSurgeriesHistory.vue?vue&type=style&index=1&id=1569afae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1569afae",
  null
  
)

export default component.exports